function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1286_3177)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1286_3177)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_1286_3177)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1347 10.9612C10.0072 11.089 9.85513 11.1896 9.68761 11.2569L7.33159 12.2011C7.08936 12.2983 6.82393 12.3222 6.56823 12.27C6.31252 12.2177 6.07778 12.0915 5.8931 11.9071C5.70842 11.7227 5.58193 11.4881 5.52931 11.2325C5.47669 10.9768 5.50025 10.7114 5.59707 10.469L6.53878 8.11168C6.60553 7.94389 6.70568 7.79141 6.83314 7.66348L11.3747 3.11835L3.35601 3.12387C2.80499 3.12478 2.27683 3.34423 1.88741 3.73406C1.49799 4.1239 1.2791 4.65229 1.27877 5.2033L1.28509 14.3806C1.28635 14.9316 1.50602 15.4596 1.89594 15.8488C2.28587 16.2381 2.81422 16.4569 3.36519 16.4572L12.5419 16.4509C13.0928 16.4498 13.6207 16.2303 14.01 15.8405C14.3993 15.4506 14.6181 14.9224 14.6184 14.3715L14.613 6.47679L10.1347 10.9612Z",
  fill: "#222222"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3956 1.50628L7.54095 8.37033C7.50915 8.40243 7.48403 8.44052 7.46703 8.48239L6.52599 10.8397C6.50172 10.9004 6.49582 10.9668 6.50902 11.0308C6.52222 11.0948 6.55394 11.1535 6.60024 11.1996C6.64675 11.2451 6.7054 11.2762 6.76915 11.2892C6.8329 11.3021 6.89903 11.2964 6.95962 11.2727L9.31297 10.3284C9.35492 10.3116 9.39301 10.2864 9.42492 10.2544L16.2815 3.39098C16.4088 3.26794 16.5104 3.12078 16.5802 2.95809C16.65 2.79539 16.6867 2.62042 16.6882 2.44338C16.6897 2.26634 16.6559 2.09078 16.5888 1.92694C16.5217 1.76311 16.4226 1.61427 16.2974 1.48912C16.1722 1.36397 16.0233 1.26502 15.8594 1.19803C15.6955 1.13105 15.5199 1.09737 15.3429 1.09897C15.1659 1.10056 14.9909 1.1374 14.8283 1.20734C14.6656 1.27727 14.5185 1.37889 14.3956 1.50628Z",
  fill: "#222222"
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1286_3177"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.973145 0.792175) rotate(-0.0394413)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1286_3177"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.973145 0.792175) rotate(-0.0394413)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_1286_3177"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.973145 0.792175) rotate(-0.0394413)"
})));

function SvgModify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.337fbca0.svg";
export { ForwardRef as ReactComponent };